// extracted by mini-css-extract-plugin
module.exports = {"Wrapper":"TabsWrapper__Wrapper_8sbzt","Content":"TabsWrapper__Content_2vXDV"};